module.exports = __webpack_public_path__ + "img/icon_info.0eeb944f.png";